"use client"

export default function Error({
  error,
}: {
  error: Error & { digest?: string }
}) {
  const digest = error?.digest ?? "xxxx"

  return (
    <div className="flex min-h-[calc(100vh-64px)] items-center justify-center px-6">
      <div className="text-center text-ui-fg-base">
        <p className="text-base">
          The site is currently down for maintenance, and we will be back soon.
        </p>
        <p className="mt-3 text-sm text-ui-fg-muted">Digest: {digest}</p>
      </div>
    </div>
  )
}
